import types from './types';

export const setMessage = (flag, code, uuidNumber = null) => ({
    type: types.SET_MESSAGE,
    flag,
    code,
    uuidNumber
});

export const hideMessage = (dispatch) => {
    dispatch(setMessage(false, '200'));
}

export const setReduxFormData = (data) => ({
    type: types.REDUX_FORM_DATA,
    data
});

export const setIsMobileBreakpoint = (isMobile) => ({
    type: types.SET_IS_MOBILE_BREAKPOINT,
    payload: isMobile
});

export default {
    setMessage,
    hideMessage,
    setIsMobileBreakpoint
}